module.exports = __webpack_public_path__ + "img/icon-sandbox.734a7643.png";